import { useMutation, useQuery } from "react-query";
import { normalFetch } from "../../fetch-api/get";
import { putApi } from "../../fetch-api/put";
import { useQueryContext } from "../../../contexts/query";


export const categoryKeys = {
    getCategories: 'getCategories',
    setCategory: 'setCategory',
}

export const useGetCategories = () => {

    return useQuery(
        categoryKeys.getCategories, () => normalFetch('settings/category'),
        {
            select: res => res?.data?.data
        }
    )
}

export const useAddCategory = (onSuccess = () => { }) => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        categoryKeys.setCategory, (payload) => putApi(payload, 'settings/category'),
        {
            onSuccess: () => {
                setToast({ message: 'category-added-success', show: true })
                queryClient.invalidateQueries([categoryKeys.getCategories])
                onSuccess()
            }
        }
    )
}

